import axios from "@/libs/api.request";

export const getMemberList = filterCond => {
  return axios.request({
    url: "member/getMemberList",
    data: filterCond,
    csrf: false,
    method: "post"
  });
};
export const getMemberOrderList = filterCond => {
  return axios.request({
    url: "member/getMemberOrderList",
    data: filterCond,
    csrf: false,
    method: "post"
  });
};
export const getMemberWithdrawOrderList = filterCond => {
  return axios.request({
    url: "member/getMemberWithdrawOrderList",
    data: filterCond,
    csrf: false,
    method: "post"
  });
};

export const withdrawFundsData = id => {
  return axios.request({
    url: "member/withdrawFundsData",
    data: { id },
    csrf: true,
    method: "post"
  });
};
